webpackJsonp([0],{

/***/ "+bCV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/d9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1trb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blogs"},[(_vm.blogPosts)?_c('div',[_c('p',{staticClass:"lead"},[_vm._v("All blog posts ("+_vm._s(_vm.blogsCount)+")")]),_vm._v(" "),_vm._l((_vm.years),function(year,i){return _c('div',{key:i,staticClass:"blog-list"},[_c('label',{staticClass:"year"},[_c('i',{staticClass:"far fa-calendar-alt"}),_vm._v("  "+_vm._s(year))]),_vm._v(" "),_vm._l((_vm.blogPosts[year]),function(b,j){return _c('div',{key:j,staticClass:"row blog-row",on:{"click":function($event){_vm.gotoBlog(b.id)}}},[_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"title pull-left"},[_c('i',{staticClass:"fas fa-angle-double-right"}),_vm._v("  "+_vm._s(b.title)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(b.month + " " + b.day))])])])})],2)})],2):_c('div',[_vm._v("\n    Loading...\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2bTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2cLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: "BlogList",
  data: function data() {
    return {
      blogsCount: 0,
      blogPosts: null,
      years: []
    };
  },

  methods: {
    gotoBlog: function gotoBlog(id) {
      this.$router.push({ path: "blogs/" + id });
    },
    formatPosts: function formatPosts(posts) {
      // Seperate years and blogs, render according to sorted years
      var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      if (!posts) {
        return;
      }

      var blogPosts = {};
      for (var i = 0; i < posts.length; i++) {
        var b = posts[i];
        //format date
        var date = new Date(b.published);
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var day = date.getDate();

        //push year only one time
        if (this.years.indexOf(year) == -1) this.years.push(year);

        b["year"] = year;
        b["month"] = month;
        b["day"] = day;

        if (!blogPosts[year]) blogPosts[year] = [];
        blogPosts[year].push(b);
      }

      //sort in descending order
      this.years.sort(function (a, b) {
        return b - a;
      });
      this.blogsCount = posts.length;
      return blogPosts;
    }
  },
  computed: {},
  created: function created() {
    console.log('created');
    var self = this;
    this.blogPosts = self.formatPosts(this.$store.state.blogs);
    if (!this.blogPosts) {
      this.$store.dispatch("getBlogs", function (blogPosts) {
        self.blogPosts = self.formatPosts(blogPosts);
        self.$store.commit('setBlogs', blogPosts);
        self.$forceUpdate();
      });
    }
  }
});

/***/ }),

/***/ "36ML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h2',{staticClass:"center"},[_vm._v("Quotes")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},_vm._l((_vm.quotes.set1),function(quote,i){return _c('blockquote',{key:i,staticClass:"success"},[_c('p',[_vm._v(_vm._s(quote.content))]),_vm._v(" "),(quote.author)?_c('footer',[_c('cite',{attrs:{"title":"Source Title"}},[_vm._v(_vm._s(quote.author))])]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"col-md-6"},_vm._l((_vm.quotes.set2),function(quote,i){return _c('blockquote',{key:i,staticClass:"success"},[_c('p',[_vm._v(_vm._s(quote.content))]),_vm._v(" "),(quote.author)?_c('footer',[_c('cite',{attrs:{"title":"Source Title"}},[_vm._v(_vm._s(quote.author))])]):_vm._e()])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7CDw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro center"},[_c('div',{staticClass:"profilePic"}),_vm._v(" "),_c('h2',{staticClass:"lead center"},[_vm._v("Hey there!")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n    I am Bibhuti Poudyal. This is my portfolio and a blog.\n    "),_c('br'),_c('br'),_vm._v("\n    View my "),_c('router-link',{staticClass:"link",attrs:{"to":"/resume"}},[_vm._v("resume")]),_vm._v("\n    and"),_c('router-link',{staticClass:"link",attrs:{"to":"/projects"}},[_vm._v(" projects")]),_vm._v(" "),_c('br'),_vm._v("\n    Read my answers on "),_c('a',{staticClass:"link",attrs:{"href":"https://www.quora.com/profile/Bibhuti-Poudyal"}},[_vm._v("Quora")]),_vm._v(" "),_c('br'),_vm._v("\n    Follow me on "),_c('a',{staticClass:"link",attrs:{"href":"https://twitter.com/bibhuti_coder"}},[_vm._v("Twitter")]),_vm._v("\n    or "),_c('a',{staticClass:"link",attrs:{"href":"https://github.com/bibhuticoder"}},[_vm._v("Github")]),_vm._v(" "),_c('br'),_vm._v("\n    Email me at "),_c('a',{staticClass:"link",attrs:{"href":"mailto:bibhutipd@gmail.com"}},[_vm._v("bibhutipd@gmail.com")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('SocialHandlers'),_vm._v(" "),_c('div',{on:{"click":_vm.scrollee}},[_c('i',{staticClass:"fas fa-chevron-down",attrs:{"id":"down"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Df/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"disqus_thread"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8GdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.projects)?_c('div',[_c('div',{staticClass:"filter-list row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchKeyword),expression:"searchKeyword"}],staticClass:"search",attrs:{"type":"text","placeholder":"Search projects.."},domProps:{"value":(_vm.searchKeyword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchKeyword=$event.target.value},_vm.search]}}),_vm._v(" "),_vm._l((_vm.filters),function(f,i){return _c('div',{key:i,staticClass:"filter",class:{'filter-active': (f===_vm.filterLanguage)},style:('color:'+_vm.colors[f]),on:{"click":function($event){_vm.setFilter(f)}}},[_vm._v("\n        "+_vm._s(f)+"\n      ")])})],2),_vm._v(" "),_c('div',{staticClass:"row projects-list"},_vm._l((_vm.projects),function(p,i){return _c('Project',{key:i,staticClass:"col-md-3",attrs:{"name":p.name,"demo_url":p.demo_url,"src_url":p.html_url,"description":p.description,"stars":p.stargazers_count,"forks":p.forks,"language":p.language,"color":_vm.colors[p.language]}})}))]):_c('div',[_c('img',{staticClass:"loading",attrs:{"src":"static/loading.gif"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8dIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project"},[_c('div',{staticClass:"title"},[_c('label',[_c('a',{attrs:{"href":_vm.demo_url,"target":"_blank","title":"Demo"}},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]),_vm._v(" "),_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : "top", arrow : true }),expression:"{ placement : \"top\", arrow : true }"}],staticClass:"pull-right",attrs:{"href":_vm.demo_url,"target":"_blank","title":"Demo"}},[_vm._m(0)])]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('label',{staticClass:"language pull-left"},[_c('i',{staticClass:"fas fa-circle",style:('color:'+ _vm.color)}),_vm._v(" "+_vm._s(_vm.language)+"\n    ")]),_vm._v(" "),_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : "top", arrow : true }),expression:"{ placement : \"top\", arrow : true }"}],staticClass:"pull-right",attrs:{"href":_vm.src_url,"target":"_blank","title":"Source Code"}},[_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"pull-right demo"},[_c('i',{staticClass:"fas fa-external-link-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"code"},[_c('i',{staticClass:"fas fa-code"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9lab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'resume',
  data: function data() {
    return {
      name: "Bibhuti Poudyal",
      profession: "Programmer | Developer",
      contacts: {
        email: "bibhutipd@gmail.com",
        address: "Babarmahal, Kathmandu",
        mobile: "+977 9810293291",
        website: "http://www.bibhutipoudyal.com.np"
      },
      qualificationsSummary: ['Skills for developing Desktop, Mobile and Web applications.', 'A firm believer of teamwork with good communication and interpersonal skill'],
      technicalSkills: [{
        name: 'HTML5',
        score: 95
      }, {
        name: 'CSS3',
        score: 70
      }, {
        name: 'Javascript',
        score: 80
      }, {
        name: 'Vue JS',
        score: 75
      }, {
        name: 'React JS',
        score: 50
      }, {
        name: 'Angular',
        score: 30
      }, {
        name: 'NodeJs',
        score: 80
      }, {
        name: 'Python',
        score: 65
      }, {
        name: 'PHP (Laravel)',
        score: 80
      }, {
        name: 'C/C++',
        score: 60
      }, {
        name: 'Java(Android)',
        score: 70
      }, {
        name: 'C#',
        score: 30
      }, {
        name: 'Teeensy',
        score: 80
      }, {
        name: 'MySQL',
        score: 60
      }, {
        name: 'Solidity(Ethereum)',
        score: 50
      }],
      extratechnicalSkills: "Android, Laravel, Firebase, Express, Socket.io,\n                            Flask, Django, Chrome extensions, ElectronJs, WinForms,\n                            PhaserJS, libGDX, MongoDB, Arduino, Google Maps API, Google Drive API,\n                            Dropbox API, OpenCV, Tensorflow, SCSS, Bootstrap, Materialize.",
      otherSkills: 'Adobe Photoshop, Illustrator',
      academics: [{
        title: 'SLC (2011)',
        metadata: 'Alpine Academy, Nayapati, Kathmandu : Secured 80.88%'
      }, {
        title: '+2 in Science (2013)',
        metadata: 'Trinity International college, Dillibazar Kathmandu : Secured 72.35% in aggregate'
      }, {
        title: 'Bachelor of Science in Computer Science and Information Technology (BScCSIT) (Jan 2015 – till now)',
        metadata: 'St Xaviers College, Maitighar, Kathmandu'
      }],
      achievements: [{
        title: 'Happy Coding App and website Competition (CAN)',
        metadata: '1st Place for project "Realtime Whiteboard"'
      }, {
        title: 'Luniva Code Jatra 2017',
        metadata: '1st Place for project "Traversity"'
      }, {
        title: 'Yomari Code Camp 2018',
        metadata: '3rd Place for project "Cryptovoting"'
      }, {
        title: 'The Kathmandu Post',
        metadata: 'An <a href="http://epaper.ekantipur.com/the-kathmandu-post/2017-11-01/6" target="_blank"> article</a> regarding Cyber Security.'
      }],
      traningsWorkshops: [{
        title: 'MIT\'s Interconnected Embedded Systems at Karkhana',
        metadata: 'IOT workshop on Teensy microcontroller (Final Project: IES-Snake)'
      }]
    };
  },

  methods: {},
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    }
  },
  created: function created() {
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "AkO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'bio',
  methods: {},
  computed: {},

  created: function created() {}
});

/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_disqus_VueDisqus_vue__ = __webpack_require__("d9EC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Bio__ = __webpack_require__("OiDD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueDisqus: __WEBPACK_IMPORTED_MODULE_0_vue_disqus_VueDisqus_vue__["a" /* default */], Bio: __WEBPACK_IMPORTED_MODULE_1__components_Bio__["a" /* default */] },
  name: "blog",
  data: function data() {
    return {
      nextPost: null,
      prevPost: null
    };
  },

  methods: {
    fetchData: function fetchData(blogId) {
      var self = this;
      this.$store.dispatch("getCurrentBlog", {
        id: blogId,
        callback: function callback() {
          //when the current blog is loaded load other blogs too.
          self.$store.dispatch("getBlogs", function () {
            //set prev and next post
            var index;
            for (var i = 0; i < self.blogs.length; i++) {
              if (self.currentBlog.id === self.blogs[i].id) index = i;
            }

            //cycle
            if (index != 0) self.prevPost = self.blogs[index - 1];else self.prevPost = self.blogs[self.blogs.length - 1];

            if (index != self.blogs.length - 1) self.nextPost = self.blogs[index + 1];else self.nextPost = self.blogs[0];
          });
        }
      });
    },
    navigate: function navigate(blogId) {

      //make al data null
      this.nextPost = null;
      this.prevPost = null;
      this.$store.commit('setCurrentBlog', null);

      //change route
      this.$router.push({ name: 'Blog', params: { id: blogId } });
      this.$route.params.id = blogId;
      this.fetchData(blogId);
    }
  },
  computed: {
    currentBlog: function currentBlog() {
      return this.$store.state.currentBlog;
    },
    blogs: function blogs() {
      return this.$store.state.blogs;
    }
  },

  created: function created() {
    this.fetchData(this.$route.params.id);
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "CsK7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'navbar',
  data: function data() {
    return {
      tabs: [
      // {name: "Home", path: 'home'},
      { name: "Resume", path: 'resume' }, { name: "Projects", path: 'projects' }]
    };
  },


  methods: {
    navigate: function navigate(to) {
      this.$router.replace({ path: '/' + to });
    }
  },

  computed: {
    currentTab: function currentTab() {
      return this.$store.state.currentTab;
    }
  }
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BlogList__ = __webpack_require__("U2xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Intro__ = __webpack_require__("xa4f");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { BlogList: __WEBPACK_IMPORTED_MODULE_0__components_BlogList__["a" /* default */], Intro: __WEBPACK_IMPORTED_MODULE_1__components_Intro__["a" /* default */] },
  name: 'home',
  created: function created() {
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "GwzN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ITWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kw7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'Project',
  props: ["name", "demo_url", "src_url", "description", "stars", "forks", "language", "color"],
  methods: {},
  computed: {},
  created: function created() {}
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b1b1b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("mOAK");
function injectStyle (ssrContext) {
  __webpack_require__("Y3aL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b1b1b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tippy__ = __webpack_require__("ybWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_tippy__);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_tippy___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */]
});

/***/ }),

/***/ "OiDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bio_vue__ = __webpack_require__("AkO8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6d16176_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bio_vue__ = __webpack_require__("gVCI");
function injectStyle (ssrContext) {
  __webpack_require__("2bTP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6d16176"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6d16176_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PcHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Project__ = __webpack_require__("wa3q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Project: __WEBPACK_IMPORTED_MODULE_0__components_Project__["a" /* default */] },
  name: "projects",
  data: function data() {
    return {
      filterLanguage: "All",
      searchKeyword: "",
      colors: {
        TypeScript: "#2b7489",
        "C++": "#f34b7d",
        "C#": "#1E88E5",
        "Jupyter Notebook": "#DA5B0B",
        Shell: "#89e051",
        Kotlin: "#F18E33",
        "Objective-C": "#438eff",
        Ruby: "#701516",
        Go: "#375eab",
        "Visual Basic": "#945db7",
        PHP: "#4F5D95",
        Java: "#b07219",
        Scala: "#DC322F",
        Makefile: "#427819",
        Perl: "#0298c3",
        Lua: "#000080",
        Vue: "#2c3e50",
        CoffeeScript: "#244776",
        HTML: "#e44b23",
        Swift: "#ffac45",
        C: "#555555",
        JavaScript: "#FFA000",
        Python: "#3572A5"
      }
    };
  },

  methods: {
    setFilter: function setFilter(lang) {
      this.filterLanguage = lang;
    },
    search: function search() {
      this.setFilter("All");
    },
    initFilters: function initFilters(projects) {
      var filters = ['All'];
      for (var i = 0; i < projects.length; i++) {
        var l = projects[i].language;
        if (filters.indexOf(l) === -1 && l !== null) filters.push(l);
      }
      return filters;
    }
  },
  computed: {
    projects: function projects() {
      if (this.filterLanguage === "All") {
        if (this.searchKeyword.length > 0) {
          var self = this;
          return this.$store.getters.projects.filter(function (project) {
            return project.name.search(new RegExp(self.searchKeyword, "i")) > 0;
          });
        } else return this.$store.getters.projects;
      } else {
        var self = this;
        return this.$store.getters.projects.filter(function (project) {
          return project.language === self.filterLanguage;
        });
      }
    },
    filters: function filters() {
      if (this.$store.state.projects) return this.initFilters(this.$store.state.projects);
      return null;
    }
  },

  created: function created() {
    var self = this;
    self.setFilter("All");
    if (!self.$store.state.projects) {
      self.$store.dispatch("getProjects", function () {});
    }
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "PwRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-inverse"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"home",on:{"click":function($event){_vm.navigate('home')}}},[_c('span',{staticClass:"white"},[_vm._v("Bibhuti")]),_vm._v(" "),_c('span',{staticClass:"green"},[_vm._v("Poudyal")])])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"to-collapse"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.name},[_c('div',{class:(tab.path===_vm.currentTab && _vm.currentTab !== null)? 'tab tab-active': 'tab',domProps:{"innerHTML":_vm._s(tab.name)},on:{"click":function($event){_vm.navigate(tab.path)}}})])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#to-collapse","aria-expanded":"false"}},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q1WI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-links"},_vm._l((_vm.socialLinks),function(h,i){return _c('button',{key:i,staticClass:"circleBtn",attrs:{"title":h.title}},[_c('a',{attrs:{"href":h.link,"target":"_blank"}},[_c('div',{style:('color:' + h.color),domProps:{"innerHTML":_vm._s(h.tag)}})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29dca470_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("heMl");
function injectStyle (ssrContext) {
  __webpack_require__("Vwru")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29dca470"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29dca470_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U08c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtWorks_vue__ = __webpack_require__("kHvR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b22d39c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtWorks_vue__ = __webpack_require__("hXhq");
function injectStyle (ssrContext) {
  __webpack_require__("CsK7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b22d39c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtWorks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b22d39c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtWorks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U2xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogList_vue__ = __webpack_require__("2cLy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4bf0d32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogList_vue__ = __webpack_require__("1trb");
function injectStyle (ssrContext) {
  __webpack_require__("GwzN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4bf0d32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4bf0d32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uopp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vwru":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y3aL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resume__ = __webpack_require__("fc3l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ArtWorks__ = __webpack_require__("U08c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Projects__ = __webpack_require__("uwSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Quotes__ = __webpack_require__("awhP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Blog__ = __webpack_require__("SGec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bio__ = __webpack_require__("OiDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Errors__ = __webpack_require__("pl3Q");












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//AIzaSyC39mYo0t5fxe3QlQ5cd2xKDnzgEVUL7JU

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Start',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/Blogs/:id',
    name: 'Blog',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Blog__["a" /* default */]
  }, {
    path: '/Home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/resume',
    name: 'Resume',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Resume__["a" /* default */]
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Projects__["a" /* default */]
  }, {
    path: '/artWorks',
    name: 'Art Works',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ArtWorks__["a" /* default */]
  }, {
    path: '/quotes',
    name: 'Quotes',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Quotes__["a" /* default */]
  }, {
    path: '/bio',
    name: 'Bio',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Bio__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_7__components_About__["a" /* default */]
  }, {
    path: '/errors/:type',
    name: 'Errors',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Errors__["a" /* default */]
  }, {
    path: "*",
    component: __WEBPACK_IMPORTED_MODULE_10__components_Errors__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialHandlers__ = __webpack_require__("eM+6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SocialHandlers: __WEBPACK_IMPORTED_MODULE_0__components_SocialHandlers__["a" /* default */] },
  name: 'about',
  methods: {},
  computed: {},
  created: function created() {
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "aY2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'quotes',
  data: function data() {
    return {
      allQuotes: [{ content: 'A river cuts through a rock not beacuse of its power but its persistance.', author: null }, { content: 'No matter how big your house is, how recent your Car is, how big your Bank balance is, our Graves will be the same size. STAY HUMBLE', author: null }, { content: 'It might take a year, it might take a day, but what\'s meant to be will always find its way.', author: null }, { content: 'You can\'t go back and change the begining but you can start where you are and change the ending.', author: 'C.S. Lewis' }, { content: 'A river cuts through a rock not beacuse of its power but its persistance.', author: null }, { content: 'Sometimes you need to burn bridges to stop yourself from crossing them again.', author: null }, { content: 'Never let a bad day make you feel like you have a bad life.', author: null }, { content: 'Don\'t judge people for the choices they make when you don\'t know the options they had to choose from.', author: null }, { content: "If it is important for you, you will find a way. If it is not, you will find an excuse.", author: null }, { content: "Success hugs you in private. Failure slaps you in public. That's LIFE.", author: "Billionare's Saying" }, { content: "If it is important for you, you will find a way. If it is not, you will find an excuse.", author: null }, { content: "Man cannot discover new oceans unless he has the courage to lose sight of the shore.", author: 'Andre Gide' }, { content: "A comfort zone is a beautiful place, but nothing ever grows there.", author: null }, { content: "The happiest people don't have the best of everything, they just make the best of everything.", author: null }, { content: "You can't stop the wave but you can learn to surf.", author: null }, { content: "Without rain nothing grows, learn to embrace the storms of your life.", author: null }, { content: "Miracles start to happen when you give as much energy to your dreams as you do to your fears.", author: null }, { content: "No matter what comes in your way, share it off and move forward. When you have a positive mindset, you can't be defeated.", author: null }, { content: "It's not the load that breaks you down, it's the way you carry it.", author: null }, { content: "Discipline is the bridge between goals and accomplishment.", author: null }, { content: "When the caterpillar thought the world was over, it became the butterfly.", author: null }, { content: "Whoever is trying to bring you down is already below you.", author: null }, { content: "Your life doesn't get better by chance, it gets better by change.", author: ' Jim Rohn' }, { content: "Life is not perfect...There is always a possibility of problems. The problems is not the end. But it's the beginning of a different life.", author: null }, { content: "Every day you wait is another day you won't get back.", author: null }, { content: "The best view comes from the highest climb.", author: null }, { content: "Courage doesn't mean you don't get afraid. Courage means you don't let fear stop you.", author: null }, { content: "One small positive thought can change your whole day.", author: null }, { content: "The meaning of life is to give life meaning.", author: "Ken Hudgins" }, { content: "The head full of fears has no space for dreams.", author: null }, { content: "Cry. Forgive. Learn. Move on. Let your tears water the seeds of your future happiness.", author: null }, { content: "Your attitude determines your direction.", author: null }, { content: "Don't stress the could haves. It should have, it would have.", author: null }, { content: "It's not how we make mistakes, But how we correct them that defines us.", author: null }, { content: "Don't Talk, Just Act. Don't Say, Just Show. Don't Promise, Just Prove.", author: null }, { content: "When life puts you in tough situations, Don't say 'Why me' say 'Try me'.", author: null }]
    };
  },

  methods: {},
  computed: {
    quotes: function quotes() {
      var sets = { set1: [], set2: [] };
      for (var i = 0; i < this.allQuotes.length / 2; i++) {
        sets.set1.push(this.allQuotes[i]);
      }for (var i = this.allQuotes.length / 2; i < this.allQuotes.length; i++) {
        sets.set2.push(this.allQuotes[i]);
      }return sets;
    }
  },

  created: function created() {
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "awhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotes_vue__ = __webpack_require__("aY2b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d072dee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotes_vue__ = __webpack_require__("36ML");
function injectStyle (ssrContext) {
  __webpack_require__("smMd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d072dee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d072dee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1733242_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("cYwH");
function injectStyle (ssrContext) {
  __webpack_require__("jRs1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1733242"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1733242_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cK1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container center"},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"lead error-msg"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('h1',[_c('i',{staticClass:"fa fa-exclamation-triangle sad",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('br'),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cYwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container center"},[_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container text"},[_c('p',{staticClass:"lead center"}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('P',{staticClass:"lead"},[_vm._v("I have also explained it  "),_c('router-link',{attrs:{"to":"/blogs/325227775290080082"}},[_vm._v("here")])],1),_vm._v(" "),_c('p',{staticClass:"lead center"},[_vm._v("\n      If you have any issues regarding the projects and blog feel free to contact me.\n      And any kind of suggestions regarding my projects, blogs or this site are highly appreciated.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('SocialHandlers')],1),_vm._v(" "),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('i',{staticClass:"fa fa-cogs",attrs:{"aria-hidden":"true"}}),_vm._v("  \n      How I built this site\n        "),_c('i',{staticClass:"fa fa-flask",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"lead"},[_c('b',[_vm._v("Domain")]),_vm._v(" : Free .np domain by  "),_c('a',{attrs:{"href":"https://register.com.np/","target":"_blank>"}},[_vm._v("Mercentile")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Hosting")]),_vm._v(" : "),_c('a',{attrs:{"href":"https://pages.github.com/","target":"_blank>"}},[_vm._v("Github Pages")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Blog")]),_vm._v(" : "),_c('a',{attrs:{"href":"https://developers.google.com/blogger/docs/3.0/getting_started","target":"_blank>"}},[_vm._v("Blogger REST API v3")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Projects")]),_vm._v(" : "),_c('a',{attrs:{"href":"https://developer.github.com/v3/","target":"_blank>"}},[_vm._v("GitHub REST API v3")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Frontend Framework")]),_vm._v(" : "),_c('a',{attrs:{"href":"https://developer.github.com/v3/","target":"_blank>"}},[_vm._v("Vue js")]),_vm._v(" with "),_c('a',{attrs:{"href":"https://vuex.vuejs.org/en/","target":"_blank"}},[_vm._v(" VueX ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Source code")]),_vm._v(" : "),_c('a',{attrs:{"href":"https://github.com/bibhuticoder/bibhuticoder.github.io","target":"_blank"}},[_vm._v("https://github.com/bibhuticoder/bibhuticoder.github.io")]),_vm._v(".\n      "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"lead"},[_c('i',{staticClass:"fa fa-hand-o-down",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d9EC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDisqus_vue__ = __webpack_require__("gNKr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9a2a8d5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueDisqus_vue__ = __webpack_require__("7Df/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDisqus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9a2a8d5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueDisqus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eM+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialHandlers_vue__ = __webpack_require__("rnaO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b46401e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialHandlers_vue__ = __webpack_require__("Q1WI");
function injectStyle (ssrContext) {
  __webpack_require__("ITWI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b46401e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialHandlers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b46401e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialHandlers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fc3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resume_vue__ = __webpack_require__("9lab");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a757302_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resume_vue__ = __webpack_require__("sbZr");
function injectStyle (ssrContext) {
  __webpack_require__("u02a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a757302"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resume_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a757302_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resume_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gNKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          self.setBaseConfig(this);
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        self.setBaseConfig(this);
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    },
    setBaseConfig: function setBaseConfig(disqusConfig) {
      var _this2 = this;

      disqusConfig.page.identifier = this.identifier || this.$route.path || window.location.pathname;
      disqusConfig.page.url = this.url || this.$el.baseURI;
      if (this.title) {
        disqusConfig.page.title = this.title;
      }
      if (this.remote_auth_s3) {
        disqusConfig.page.remote_auth_s3 = this.remote_auth_s3;
      }
      if (this.key) {
        disqusConfig.page.api_key = this.key;
      }
      if (this.sso_config) {
        disqusConfig.sso = this.sso_config;
      }

      disqusConfig.callbacks.onReady = [function () {
        _this2.$emit('ready');
      }];
    }
  }
});

/***/ }),

/***/ "gVCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bio"},[_c('div',{staticClass:"pic"}),_vm._v(" "),_c('p',[_c('br'),_vm._v("        \n    Hello, I am Bibhuti Poudyal, a programmer, designer, dreamer and an artist who\n    likes art of every form. I am tech enthusiastic spending a lot of time with computer,\n    learning and experimenting stuffs.          \n    "),_c('br'),_vm._v("\n    In my free time I experiment with different technologies. You can view all of my projects\n    "),_c('a',{attrs:{"href":"http://www.bibhutipoudyal.com.np/#/projects"}},[_vm._v("here")]),_vm._v(". Also I write answers on\n    "),_c('a',{attrs:{"href":"https://www.quora.com/profile/Bibhuti-Poudyal"}},[_vm._v("Quora")]),_vm._v(".\n    Other than technical stuffs, I like books, movies, meditation, digital art and Cooking.\n    I share all those experiences on my "),_c('a',{attrs:{"href":"http://www.bibhutipoudyal.com.np/#/"}},[_vm._v("blog")]),_vm._v(".\n    Be sure to check it out. \n    "),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hXhq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",attrs:{"id":"artwork-list"}},_vm._l((_vm.artworks),function(a,i){return _c('div',{key:i,staticClass:"col-xs-6 col-md-4",on:{"click":function($event){_vm.currentArtwork = a}}},[_c('div',{staticClass:"thumbnail pic-thumbnai"},[_c('img',{staticClass:"art-pic",attrs:{"src":a.src,"data-toggle":"modal","data-target":"#art-large","data-name":a.title}}),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('h5',{staticClass:"artname"},[_vm._v(_vm._s(a.title))])])])])})),_vm._v(" "),_c('div',{staticClass:"modal fade bs-example-modal-lg",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"myLargeModalLabel","id":"art-large"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"thumbnail"},[(_vm.currentArtwork)?_c('img',{attrs:{"src":_vm.currentArtwork.src}}):_vm._e()])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('h1',{staticClass:"center"},[_vm._v("Art Works")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"lead center"},[_vm._v("Digital arts built with Adobe Photoshop & Illustrater.")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "heMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.currentBlog)?_c('div',{staticClass:"content"},[_c('h1',{staticClass:"center"},[_vm._v(_vm._s(_vm.currentBlog.title))]),_vm._v(" "),_c('p',{staticClass:"center"},[_vm._v(" By Bibhuti Poudyal | "+_vm._s(_vm.currentBlog.day + " " + _vm.currentBlog.month + ", " + _vm.currentBlog.year)+" ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentBlog.content)}}),_vm._v(" "),_c('bio'),_vm._v(" "),_c('div',{staticClass:"comments"},[_c('vue-disqus',{attrs:{"shortname":"bibhuticoder","identifier":_vm.currentBlog.id,"url":"'http://localhost:8080'","title":'Blog' + _vm.currentBlog.id}})],1)],1):_c('div',[_c('img',{staticClass:"loading",attrs:{"src":"static/loading.gif"}})]),_vm._v(" "),(_vm.prevPost)?_c('div',{staticClass:"nav-post left-post",on:{"click":function($event){_vm.navigate(_vm.prevPost.id)}}},[_c('div',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.prevPost.title))])]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.nextPost)?_c('div',{staticClass:"nav-post right-post",on:{"click":function($event){_vm.navigate(_vm.nextPost.id)}}},[_c('div',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.nextPost.title))])]),_vm._v(" "),_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow"},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow"},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jRs1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kHvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'artWorks',
  data: function data() {
    return {
      currentArtwork: null,
      artworks: [{
        title: 'Landscape',
        tool: 'Photoshop',
        src: 'https://4.bp.blogspot.com/-x58zdSxeAUI/WKb2HIlvcSI/AAAAAAAAApQ/bqKlU5t3nwEGEaPI0COPSJkb2Qna_z7zgCLcB/s640/landscape.png'
      }, {
        title: 'Cloudy Day',
        tool: 'Photoshop',
        src: 'https://4.bp.blogspot.com/-XvhEpvAa-2I/WKhI3TZeUbI/AAAAAAAAAqU/b6ZDqUaaErIA9e2qavHPMyU0ftgOh3EbwCLcB/s640/cloudSun-land.png'
      }, {
        title: 'Evening',
        tool: 'Photoshop',
        src: 'https://2.bp.blogspot.com/-rmHSkhLZoHM/WKhH3LXU-mI/AAAAAAAAAqI/sokU2oUW0Gk_BWggiQFnmi6kgmRXQ88YwCLcB/s640/land-cloud.png'
      }, {
        title: 'One',
        tool: 'Photoshop',
        src: 'https://4.bp.blogspot.com/-w7MOrGdbcu4/U6aI6NFd6qI/AAAAAAAAAM0/MnSMQ5JlPgI/s1600/army.jpg'
      }, {
        title: 'Nepal',
        tool: 'Photoshop',
        src: 'https://1.bp.blogspot.com/-QG3dMjeZ6GQ/VB0F9-ppeXI/AAAAAAAAAPI/Pe9tKIuQtl4/s1600/Nepal.jpg'
      }]
    };
  },


  methods: {},
  computed: {},
  created: function created() {
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
});

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35576aba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("wQjI");
function injectStyle (ssrContext) {
  __webpack_require__("oc//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35576aba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35576aba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lY77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'errors',
  data: function data() {
    return {
      errorMsg: "The page you are looking for doesn't exist."

    };
  },

  methods: {},
  computed: {},

  created: function created() {
    var error = this.$route.params.type;

    //demo_not_found
    if (error === 'demo_not_found') {
      this.errorMsg = 'Sorry! Demo for the project is not available. Instead you can download the source and run it locally.\n        <br><br> <a href="https://github.com/bibhuticoder/' + this.$route.query.name + '">View Source Code</a>';
    }
  }
});

/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a71fa89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("PwRW");
function injectStyle (ssrContext) {
  __webpack_require__("yYar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a71fa89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a71fa89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mOAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"id":"view"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oc//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    projects: null,
    blogs: null,
    currentBlog: null,
    currentTab: null
  },

  getters: {
    projects: function projects(state) {
      return state.projects;
    },
    blogs: function blogs(state) {
      return state.blogs;
    },
    currentBlog: function currentBlog(state) {
      return state.currentBlog;
    },
    currentTab: function currentTab(state) {
      return state.currentTab;
    }
  },

  mutations: {
    setCurrentTab: function setCurrentTab(state, tab) {
      state.currentTab = tab;
    },
    setProjects: function setProjects(state, projects) {

      //remove forked projects
      var filtered = projects.filter(function (p) {
        return p.fork === false;
      });

      //generate demo links
      var final = filtered.map(function (p) {
        if (p.has_pages) p['demo_url'] = "https://bibhuticoder.github.io/" + p.name;else p['demo_url'] = "/#/errors/demo_not_found?name=" + p.name;
        return p;
      });

      state.projects = final;
    },
    setBlogs: function setBlogs(state, blogs) {
      state.blogs = blogs;
    },
    setCurrentBlog: function setCurrentBlog(state, currentBlog) {
      if (currentBlog === null) {
        state.currentBlog = null;return;
      };
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var date = new Date(currentBlog.published);
      var year = date.getFullYear() + "";
      var month = months[date.getMonth()];
      var day = date.getDate();

      currentBlog["year"] = year;
      currentBlog["month"] = month;
      currentBlog["day"] = day;

      state.currentBlog = currentBlog;
    }
  },

  actions: {
    getProjects: function getProjects(context, callback) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.github.com/users/bibhuticoder/repos?sort=updated&per_page=100&page=1').then(function (response) {
        context.commit('setProjects', response.data);
        callback();
      }).catch(function (e) {
        console.log(e);
      });
    },
    getBlogs: function getBlogs(context, callback) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://www.googleapis.com/blogger/v3/blogs/6929645571399469422/posts?key=AIzaSyC39mYo0t5fxe3QlQ5cd2xKDnzgEVUL7JU&orderBy=published&fetchBodies=false').then(function (response) {
        context.commit('setBlogs', response.data.items);
        callback(response.data.items);
      }).catch(function (e) {
        console.log(e);
      });
    },
    getCurrentBlog: function getCurrentBlog(context, payload) {
      context.commit('setCurrentBlog', null);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://www.googleapis.com/blogger/v3/blogs/6929645571399469422/posts/' + payload.id + '?key=AIzaSyC39mYo0t5fxe3QlQ5cd2xKDnzgEVUL7JU').then(function (response) {
        context.commit('setCurrentBlog', response.data);
        payload.callback();
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ "pl3Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Errors_vue__ = __webpack_require__("lY77");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6934e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Errors_vue__ = __webpack_require__("cK1M");
function injectStyle (ssrContext) {
  __webpack_require__("vnLB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fb6934e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Errors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6934e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Errors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rnaO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  name: 'SocialHandlers',
  data: function data() {
    return {
      socialLinks: [{
        title: "Github",
        link: "https://github.com/bibhuticoder",
        color: "#373737",
        tag: '<i class="fab fa-github-alt" aria-hidden="true"></i>'
      }, {
        title: "Google+",
        link: "https://plus.google.com/+Bibhutipd",
        color: "#CE3E2E",
        tag: '<i class="fab fa-google-plus-g" aria-hidden="true"></i>'
      }, {
        title: "Twitter",
        link: "https://twitter.com/bibhuti_coder",
        color: "deepskyblue",
        tag: '<i class="fab fa-twitter" aria-hidden="true"></i>'
      }, {
        title: "Quora",
        link: "https://www.quora.com/profile/Bibhuti-Poudyal",
        color: "maroon",
        tag: '<i class="fab fa-quora" aria-hidden="true"></i>'
      }, {
        title: "LinkedIn",
        link: "https://www.linkedin.com/in/bibhuti-poudyal-4883aa116/",
        color: "royalblue",
        tag: '<i class="fab fa-linkedin-in" aria-hidden="true"></i>'
      }]
    };
  },

  methods: {},
  computed: {},
  created: function created() {}
});

/***/ }),

/***/ "sbZr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"resume"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"profession"},[_vm._v(_vm._s(_vm.profession))]),_vm._v(" "),_c('div',{staticClass:"pic"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6",staticStyle:{"text-align":"right"}},[_c('div',{staticClass:"content qualificatons"},[_c('h3',[_vm._v("Summary of qualifications")]),_vm._v(" "),_c('ul',_vm._l((_vm.qualificationsSummary),function(q){return _c('li',[_vm._v(_vm._s(q))])}))]),_vm._v(" "),_c('div',{staticClass:"content technical-skills"},[_c('h3',[_vm._v("Technical Skills")]),_vm._v(" "),_c('table',{staticClass:"technical-skills"},_vm._l((_vm.technicalSkills),function(t){return _c('tr',[_c('td',[_vm._v(_vm._s(t.name))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"scorebar"},[_c('div',{staticClass:"score",style:('width:'+ t.score + '%')})])])])}))]),_vm._v(" "),_c('div',{staticClass:"content extra-technical-skills"},[_c('h3',[_vm._v("Frameworks, libraries & APIs")]),_vm._v("\n          "+_vm._s(_vm.extratechnicalSkills)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"content other-skills"},[_c('h3',[_vm._v("And also some")]),_vm._v("\n          "+_vm._s(_vm.otherSkills)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6",staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"content academics"},[_c('h3',[_vm._v("Academic")]),_vm._v(" "),_c('ul',_vm._l((_vm.academics),function(a){return _c('li',[_c('label',[_vm._v(_vm._s(a.title))]),_c('br'),_vm._v("\n              "+_vm._s(a.metadata)+"\n              "),_c('br'),_c('br')])}))]),_vm._v(" "),_c('div',{staticClass:"content achievements"},[_c('h3',[_vm._v("Achievements")]),_vm._v(" "),_c('ul',_vm._l((_vm.achievements),function(a){return _c('li',[_c('label',[_vm._v(_vm._s(a.title))]),_c('br'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(a.metadata)}}),_vm._v(" "),_c('br')])}))]),_vm._v(" "),_c('div',{staticClass:"content traningsWorkshops"},[_c('h3',[_vm._v("Tranings and Workshops")]),_vm._v(" "),_c('ul',_vm._l((_vm.traningsWorkshops),function(t){return _c('li',[_c('label',[_vm._v(_vm._s(t.title))]),_c('br'),_vm._v("\n              "+_vm._s(t.metadata)+"\n              "),_c('br'),_c('br')])}))]),_vm._v(" "),_c('div',{staticClass:"content contacts"},[_c('h3',[_vm._v("Contact me")]),_vm._v(" "),_c('ul',{staticClass:"null"},[_c('li',[_c('span',{staticClass:"glyphicon glyphicon-envelope"}),_vm._v("\n              "+_vm._s(_vm.contacts.email)+"\n            ")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"glyphicon glyphicon-globe"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.contacts.website,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.contacts.website)+"\n              ")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"glyphicon glyphicon-home"}),_vm._v("\n              "+_vm._s(_vm.contacts.address)+"\n            ")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"glyphicon glyphicon-phone"}),_vm._v("\n              "+_vm._s(_vm.contacts.mobile)+"\n            ")])])])])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"download",attrs:{"href":"https://drive.google.com/open?id=1wPOtvdEnsY1JTbAvJZZ_pf8zj-ZcTRQy","target":"_blank","title":"Download in PDF"}},[_c('i',{staticClass:"far fa-file-pdf"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "smMd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u02a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uXHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialHandlers__ = __webpack_require__("eM+6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SocialHandlers: __WEBPACK_IMPORTED_MODULE_0__components_SocialHandlers__["a" /* default */] },
  name: 'Intro',
  data: function data() {
    return {};
  },

  methods: {
    scrollee: function scrollee() {
      document.querySelector('.blogs').scrollIntoView({
        behavior: 'smooth'
      });
    }
  },
  computed: {},
  created: function created() {}
});

/***/ }),

/***/ "uwSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("PcHo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c414bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("8GdF");
function injectStyle (ssrContext) {
  __webpack_require__("Uopp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09c414bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c414bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vnLB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wQjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Intro'),_vm._v(" "),_c('BlogList')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wa3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("Kw7b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d7dcf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("8dIw");
function injectStyle (ssrContext) {
  __webpack_require__("/d9P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54d7dcf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d7dcf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__ = __webpack_require__("lfLh");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__["a" /* default */] },
  name: "app"
});

/***/ }),

/***/ "xa4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__("uXHU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d33caf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__("7CDw");
function injectStyle (ssrContext) {
  __webpack_require__("+bCV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d33caf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d33caf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yYar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a1b66527c41eb2def487.js